export default __webpack_public_path__ + "static/media/premium-plan-img.4d5d1976.png";